import { render, staticRenderFns } from "./DepthChart.vue?vue&type=template&id=03bf1420&scoped=true&"
import script from "./DepthChart.vue?vue&type=script&lang=ts&"
export * from "./DepthChart.vue?vue&type=script&lang=ts&"
import style0 from "./DepthChart.vue?vue&type=style&index=0&id=03bf1420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf1420",
  null
  
)

export default component.exports